/**
 * 히어로 텍스트 타이핑 애니메이션 컨트롤러.
 *
 * [data-fw-hero-text] 요소의 textContent 를 한 글자씩 `<span class="char">` 로 분할하고
 * 각 span 의 animation-delay 를 80ms 간격으로 설정해 staggered fade-in 효과를 만든다.
 * 줄바꿈(\n) 은 `<br>` 로 치환, 스페이스는 NBSP 로 보존.
 *
 * CSS 계약: 디자이너가 `.char` 에 keyframes 애니메이션을 정의해야 한다 (opacity 0→1 등).
 */
export const HERO_TEXT_CONTROLLER_SCRIPT = `
<script data-fw-hero-text-controller>
(function () {
  function init() {
    var els = document.querySelectorAll('[data-fw-hero-text]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.dataset.fwHeroTextInit) continue;
      el.dataset.fwHeroTextInit = '1';
      var text = (el.textContent || '').replace(/^\\s+|\\s+$/g, '');
      if (!text) continue;
      var lines = text.split(/\\r?\\n/);
      while (el.firstChild) el.removeChild(el.firstChild);
      var perChar = 80;
      var delay = 0;
      for (var li = 0; li < lines.length; li++) {
        if (li > 0) { el.appendChild(document.createElement('br')); delay += 200; }
        var line = lines[li];
        for (var ci = 0; ci < line.length; ci++) {
          var ch = line.charAt(ci);
          if (ch === ' ') {
            el.appendChild(document.createTextNode('\\u00A0'));
            delay += perChar;
          } else {
            var span = document.createElement('span');
            span.className = 'char';
            span.textContent = ch;
            span.style.animationDelay = delay + 'ms';
            el.appendChild(span);
            delay += perChar;
          }
        }
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
</script>
`;
//# sourceMappingURL=hero-text.js.map